module.exports = __webpack_public_path__ + "static/media/temp-pricing-testimonials.91036a8f.png";